import React, { useState, useEffect } from 'react';
import { Form, ListGroup } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

const DateHour = ({ placeData, selectedHour, onDateChange }) => {
  const { date: urlDate, hour: urlHour } = useParams();
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState('');
  const [hours, setHours] = useState([]);

  useEffect(() => {
    if (placeData && placeData.dates && placeData.dates.length > 0) {
      const initialDate =
        placeData.dates.find((entry) => entry.date === urlDate)?.date ||
        placeData.dates[0].date;

      setSelectedDate(initialDate);
      setHours(
        placeData.dates.find((entry) => entry.date === initialDate)?.hours || []
      );
    }
  }, [placeData, urlDate]);

  const handleDateChange = (event) => {
    const selected = event.target.value;
    setSelectedDate(selected);

    const selectedData = placeData.dates.find((d) => d.date === selected);
    setHours(selectedData ? selectedData.hours : []);

    navigate(
      `/arenas/${placeData.arenaId}/${placeData.arenaName}/${placeData.placeName}/${selected}/${urlHour || ''}`
    );

    if (onDateChange) {
      onDateChange(selected);
    }
  };

  const handleHourClick = (hour) => {
    navigate(
      `/arenas/${placeData.arenaId}/${placeData.arenaName}/${placeData.placeName}/${selectedDate}/${hour}`
    );
  };

  if (!placeData || !placeData.dates) {
    return <div>Carregando dados...</div>;
  }

  if (placeData.dates.length === 0) {
    return <div>Nenhuma data disponível.</div>;
  }

  return (
    <div>
      <Form.Group controlId="date-select">
        <Form.Label>Data</Form.Label>
        <br />
        <Form.Select
          value={selectedDate}
          onChange={handleDateChange}
          className="date-select"
        >
          {placeData.dates.map((entry, index) => {
            // Corrige o parsing da data para evitar problemas de timezone
            const [year, month, day] = entry.date.split('-').map(Number);
            const date = new Date(Date.UTC(year, month - 1, day));
            
            const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']; // Atenção: getUTCDay() retorna 0-6 (Dom-Sáb)
            const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

            const weekday = weekdays[date.getUTCDay()];
            const dayFormatted = date.getUTCDate().toString().padStart(2, '0');
            const monthFormatted = months[date.getUTCMonth()];

            const formattedDate = `${weekday}, ${dayFormatted}/${monthFormatted}`;

            return (
              <option key={index} value={entry.date}>
                {formattedDate}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <ListGroup className="mt-3 hour-list">
        <Form.Label>Horário</Form.Label>
        {hours.length > 0 ? (hours.map((hourEntry, index) => (
            <ListGroup.Item
              key={index}
              className={hourEntry.hour === selectedHour ? 'active' : ''}
              onClick={() => handleHourClick(hourEntry.hour)}
              style={{ cursor: 'pointer' }}
            >
              {hourEntry.hour}:00 - {hourEntry.hour}:59
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item>Sem horários disponíveis</ListGroup.Item>
        )}
      </ListGroup>
    </div>
  );
};

export default DateHour;
